import React from 'react';
//Components
import {Animated, navigation, View} from 'react-native';
import {Label, Ripple} from "components/src/components";
//third party
import PropTypes from 'prop-types';
//Utils
import {Color, CommonStyle, Icon, IS_WEB, ThemeUtils} from 'components/src/utils'
import styles from './styles';


const AnimatedIcon = Animated.createAnimatedComponent(Icon);
const MarginLeft = (ThemeUtils.isTablet() ? ThemeUtils.relativeRealWidth(5) : 20) + ThemeUtils.fontXXLarge + ThemeUtils.fontXXSmall

class Header extends React.Component {

    getHeaderTitleMarginTop = () => {
        return this.props.animatedValue.interpolate({
            inputRange: [0, 62],
            outputRange: [ThemeUtils.isTablet() ? ThemeUtils.relativeRealWidth(13) : ThemeUtils.relativeRealHeight(IS_WEB ? 9.6 : 9.3), (ThemeUtils.relativeRealHeight(8) - ThemeUtils.fontXXLarge) / 2],
            extrapolateRight: 'clamp'
        })
    };

    getHeaderTitleMarginStart = () => {
        return this.props.animatedValue.interpolate({
            inputRange: [0, 62],
            outputRange: [this.props.initialMarginLeft, MarginLeft],
            extrapolate: 'clamp'

        })
    };

    getOpacityUp = () => {
        return this.props.animatedValue.interpolate({
            inputRange: [0, 35],
            outputRange: [0, 1],
            extrapolate: 'clamp'
        })
    };

    getOpacityDown = () => {
        return this.props.animatedValue.interpolate({
            inputRange: [0, 35],
            outputRange: [1, 0],
            extrapolate: 'clamp'
        })
    };

    render() {
        const {
            headerLeft,
            headerRightFirst,
            headerRightSecond,
            title,
            headerRightThird,
            onPressRightThird,
            image,
            badge,
            navigation,
            onPressLeft,
            onPressRightFirst,
            onPressRightSecond,
            renderHeaderFirst,
            animatedTitle,
            renderTitle,
            animatedValue,
            style,
            tintColor,

        } = this.props;

        const headerTitleMarginStart = animatedValue ? this.getHeaderTitleMarginStart() : 80;
        const headerTitleMarginTop = animatedValue ? this.getHeaderTitleMarginTop() : 80;
        const opacityUp = animatedValue ? this.getOpacityUp() : 1;
        const opacityDown = animatedValue ? this.getOpacityDown() : 1;
        const ICON_SIZE = ThemeUtils.responsiveScale(25)

        return (
            <View style={styles.container}>
                <Animated.View style={[styles.headerBg, style, {opacity: opacityUp}]}/>
                <Animated.View style={[styles.headerCont]}>
                    {title || renderTitle ? (
                        <View style={[styles.headerTitleCont, this.props.titleStyle]}>
                            {title ? (
                                <Icon name={title}
                                      color={Color.COLOR_ACCENT}
                                      size={ThemeUtils.responsiveScale(40)}/>
                            ) : renderTitle()}
                        </View>) : null}


                    <Ripple rippleColor={Color.WHITE}
                            onPress={() => onPressLeft ? onPressLeft() : navigation && navigation.goBack()}
                            rippleContainerBorderRadius={20}
                            style={styles.icHeader}>
                        {animatedTitle ?
                            (<AnimatedIcon name={headerLeft}
                                           style={{position: 'absolute', zIndex: 10, opacity: opacityUp}}
                                           color={Color.WHITE}
                                           size={ICON_SIZE}/>) : null}
                        <AnimatedIcon name={headerLeft}
                                      style={{opacity: opacityDown}}
                                      color={tintColor}
                                      size={ICON_SIZE}/>
                    </Ripple>

                    <View style={styles.icHeaderRightCont}>
                        {headerRightFirst ?
                            (<Ripple rippleColor={Color.WHITE}
                                     onPress={onPressRightFirst}
                                     rippleContainerBorderRadius={20}
                                     style={styles.icHeader}>
                                {badge ? (
                                    <View style={CommonStyle.dot}/>
                                ) : null}
                                {animatedTitle ? <AnimatedIcon name={headerRightFirst}
                                                               style={{
                                                                   position: 'absolute',
                                                                   zIndex: 10,
                                                                   opacity: opacityUp
                                                               }}
                                                               size={ICON_SIZE}
                                                               color={Color.WHITE}/> : null}
                                <AnimatedIcon name={headerRightFirst}
                                              size={ICON_SIZE}
                                              style={{opacity: opacityDown}}
                                              color={tintColor}/>
                            </Ripple>) : renderHeaderFirst ? (
                                <Ripple rippleColor={Color.WHITE}
                                        onPress={onPressRightFirst}
                                        rippleContainerBorderRadius={20}
                                        style={styles.icHeader}>
                                    {renderHeaderFirst()}
                                </Ripple>) : null}
                        {headerRightSecond ? (
                            <Ripple rippleColor={Color.WHITE}
                                    onPress={onPressRightSecond}
                                    rippleContainerBorderRadius={20}
                                    style={styles.icHeader}>
                                {animatedTitle ? <AnimatedIcon name={headerRightSecond}
                                                               style={{
                                                                   position: 'absolute',
                                                                   zIndex: 10,
                                                                   opacity: opacityUp
                                                               }}
                                                               size={ICON_SIZE}
                                                               color={Color.WHITE}/> : null}
                                <AnimatedIcon name={headerRightSecond}
                                              size={ICON_SIZE}
                                              style={{opacity: opacityDown}}
                                              color={tintColor}/>
                            </Ripple>) : null}

                        {headerRightThird ? (
                            <Ripple rippleColor={Color.WHITE}
                                    onPress={onPressRightThird}
                                    rippleContainerBorderRadius={20}
                                    style={styles.icHeader}>
                                {animatedTitle ? <AnimatedIcon name={headerRightThird}
                                                               style={{
                                                                   position: 'absolute',
                                                                   zIndex: 10,
                                                                   opacity: opacityUp
                                                               }}
                                                               size={ICON_SIZE}
                                                               color={Color.WHITE}/> : null}
                                <AnimatedIcon name={headerRightThird}
                                              size={ICON_SIZE}
                                              style={{opacity: opacityDown}}
                                              color={tintColor}/>
                            </Ripple>) : null}
                    </View>
                </Animated.View>
                {animatedTitle ? (

                    <Animated.View style={[
                        styles.animatedTitleCont, {

                            transform: [{
                                translateY: headerTitleMarginTop
                            }, {
                                translateX: headerTitleMarginStart
                            }],
                        },
                    ]}>


                        <Label xlarge
                               font_medium
                               style={{
                                   // width: ThemeUtils.relativeRealWidth(100) - ThemeUtils.COMMON_HORIZONTAL_MARGIN,
                                   opacity: opacityDown
                               }}
                               color={Color.PRIMARY}>
                            {animatedTitle}
                        </Label>
                        <Label large
                               font_medium
                               singleLine
                               style={{
                                   width: ThemeUtils.relativeRealWidth(60),
                                   position: 'absolute',
                                   opacity: opacityUp
                               }}
                               color={Color.WHITE}>
                            {animatedTitle}
                        </Label>
                    </Animated.View>
                ) : null}
            </View>
        );
    }
}

export default Header;

Header.defaultProps = {
    headerLeft: 'arrow-l',
    tintColor: Color.PRIMARY,
    initialMarginLeft: MarginLeft
};

Header.propTypes = {
    headerLeft: PropTypes.string,
    initialMarginLeft: PropTypes.number,
    navigation: PropTypes.object.isRequired,
    onPressLeft: PropTypes.func,
    onPressRightFirst: PropTypes.func,
    onPressRightSecond: PropTypes.func,
    renderTitle: PropTypes.func,
    headerRightFirst: PropTypes.string,
    headerRightSecond: PropTypes.string,
    title: PropTypes.string,
    image: PropTypes.number,
    animatedValue: PropTypes.object,
    animatedTitle: PropTypes.string,
    tintColor: PropTypes.string
};
